/* Normalizes stray leading whitespace in spec-table cells.
   Some legacy product descriptions have inconsistent manual indentation
   (a mix of &nbsp; runs and plain spaces before cell labels), which makes
   some rows sit visibly further left/right than others even though the
   CSS padding is identical. This trims leading whitespace/&nbsp; from the
   first text node in every table cell, purely at render time — the
   underlying product content is never modified. */
(function () {
  function normalize() {
    document.querySelectorAll('.rte table td, .rte table th').forEach(function (cell) {
      var walker = document.createTreeWalker(cell, NodeFilter.SHOW_TEXT);
      var node = walker.nextNode();
      if (node) {
        node.textContent = node.textContent.replace(/^[\s ]+/, '');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalize);
  } else {
    normalize();
  }
})();
